import { render } from "./PortadaNosotros.vue?vue&type=template&id=7b93f485&scoped=true"
import script from "./PortadaNosotros.vue?vue&type=script&lang=js"
export * from "./PortadaNosotros.vue?vue&type=script&lang=js"

import "./PortadaNosotros.vue?vue&type=style&index=0&id=7b93f485&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b93f485"]])

export default __exports__